<template>
    <div class="terminos-de-uso">
        <h1 class="title">Términos de Uso</h1>
        <div class="content">
            <h2>1. Aceptación de los términos</h2>
            <p>
                Al acceder y utilizar este servicio de streaming, usted acepta estar sujeto a estos términos de uso. Si no está de acuerdo con alguna parte de estos términos, no
                podrá utilizar nuestro servicio.
            </p>

            <h2>2. Cambios en los términos</h2>
            <p>
                Nos reservamos el derecho de modificar estos términos en cualquier momento. Su uso continuado del servicio después de dichos cambios constituye su aceptación de los
                nuevos términos.
            </p>

            <h2>3. Uso del servicio</h2>
            <p>
                Usted se compromete a utilizar el servicio solo para fines legales y de acuerdo con estos términos. No debe usar el servicio de ninguna manera que pueda dañar,
                deshabilitar o sobrecargar nuestros servidores o redes.
            </p>

            <h2>4. Cuentas de usuario</h2>
            <p>
                Para acceder a ciertas funciones del servicio, es posible que deba crear una cuenta. Usted es responsable de mantener la confidencialidad de su cuenta y contraseña.
            </p>

            <h2>5. Contenido</h2>
            <p>
                Nuestro servicio permite el acceso a contenido que puede estar protegido por derechos de autor y otras leyes de propiedad intelectual. Usted se compromete a no
                copiar, reproducir, distribuir o crear trabajos derivados de este contenido, a menos que esté expresamente autorizado por nosotros.
            </p>
        </div>
        <div class="button-container">
            <router-link to="/" class="back-button">
                <span class="button-icon">🏠</span>
                Volver a la página principal
            </router-link>
        </div>
        <footer-component />
    </div>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue';

export default {
    name: 'TerminosDeUso',
    components: {
        FooterComponent,
    },
};
</script>

<style scoped>
.terminos-de-uso {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    background-color: var(--color-background);
    color: var(--color-text);
}

.title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 2rem;
    color: var(--color-title);
}

.content {
    background-color: var(--color-background-light);
    border-radius: 15px;
    padding: 2rem;
    margin-bottom: 2rem;
}

h2 {
    color: var(--color-accent);
    margin-top: 1.5rem;
    margin-bottom: 1rem;
}

p {
    margin-bottom: 1rem;
    line-height: 1.6;
}

.button-container {
    display: flex;
    justify-content: center;
    margin: 3rem 0;
}

.back-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    background-color: var(--color-accent);
    color: var(--color-text);
    text-decoration: none;
    border-radius: 25px;
    font-size: 1rem;
    font-weight: bold;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
    background-color: var(--color-accent-hover);
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.button-icon {
    font-size: 1.2rem;
    margin-right: 0.5rem;
}
</style>
